<template>
  <div class="page homepage">
    <GeneralHeader :header="home.generalHeader[0]" type="in-home" />
    <IconSection :item="home.carosello[0]" type="default" />
    <ImageTextLinkSwiper :item="home.carosello[1]" />
    <TextImageWithBg :block="home.sezioneImmagineTesto[0]" />
    <TextImageWithBg :block="home.sezioneImmagineTesto[1]" />
    <LazyWidgetModelAnimation />
    <IconSection :item="home.carosello[2]" type="lime-bg" />
    <PagesNewsNewsSection :item="home.carosello[3]" />
  </div>
</template>

<script setup>
import { useStore } from '@/store/index.js'
import queries from '@/graphql/craft/queries/index.js'

const { configuration } = useStore()

// Fetch Data
const query = queries.home.getHome

const variables = computed(() => ({
  site: configuration.site,
}))

const { data } = await useGraphql(query, variables)

if (!data.value.homepageEntries?.[0]) {
  throw createError({ statusCode: 404 })
}
const home = computed(() => data.value.homepageEntries?.[0])
const seo = computed(() => data.value?.homepageEntries?.[0]?.seo || {})

// Seo
useSeo({
  ...seo.value,
  meta: [
    {
      name: 'description',
      content: seo.value?.description,
    },
  ],
})
</script>
